export const createDynamicLink = (isProdMode=process.env.NODE_ENV==="production") => {
    console.log(isProdMode)

    // if(process.env.REACT_APP_CONFIG){
    //   try {
    //     const data = JSON.parse(process.env.REACT_APP_CONFIG);
    //     console.log(data);

    //     Object.keys(data).forEach((key) => {
    //       localStorage.setItem(key,data[key]);
    //     });
        
    //   } catch (error) {
    //     console.log(error,"error in dynamic link while config");
        
    //   }
    // }

    const link = document.createElement("link");
    link.href = `${process.env.PUBLIC_URL}/style.css?${process.env.REACT_APP_VERSION}`;
    link.rel = "stylesheet";
    link.type = "text/css";
    document.head.appendChild(link);

    if(process.env.REACT_APP_GA_ENABLED === "true"){
        const gtmId = isProdMode ? process.env.REACT_APP_DEV_G_TAG_ID:process.env.REACT_APP_DEV_G_TAG_ID
        const script_G_T_M = document.createElement("script");
        script_G_T_M.innerHTML = `
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "${gtmId.toString()}");`;
    
    
          const noscript_G_T_M = document.createElement("noscript");
          const iframe = document.createElement("iframe");
          iframe.src = `https://www.googletagmanager.com/ns.html?id=${isProdMode ?  process.env.REACT_APP_PROD_G_TAG_ID : 'GTM-WZ3JJ7KC'}`;
          iframe.height = "0";
          iframe.width = "0";
          iframe.style.display = "none";
          iframe.style.visibility = "hidden";
          noscript_G_T_M.appendChild(iframe);

          document.head.appendChild(script_G_T_M);
          document.body.appendChild(noscript_G_T_M);
    }

  }